import axios, { AxiosError, AxiosResponse } from "axios";

import { BACKEND_URLS } from "config/backend";
import { clearAccessToken, getAccessToken } from "lib/auth/authToken";

const createAxiosInstance = (baseURL: string, withAuth = false) => {
  const instance = axios.create({ baseURL });

  const handleSuccess = (response: AxiosResponse) => {
    return response;
  };

  const handleError = async (error: AxiosError) => {
    if (withAuth) {
      const status = error.response?.status;
      const code = (error.response?.data as { code?: string } | undefined)?.code;

      // Clear JWT on auth failure or wallet mismatch so the UI can re-login.
      if (status === 401 || (status === 403 && code === "WALLET_MISMATCH")) {
        clearAccessToken();
      }
    }
    return Promise.reject(error);
  };

  instance.interceptors.request.use(
    async (config) => {
      if (withAuth) {
        const token = getAccessToken();
        if (token) {
          config.headers.set("Authorization", `Bearer ${token}`);
        }
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  instance.interceptors.response.use(handleSuccess, handleError);

  return instance;
};

/** Main Nectar backend — attaches Bearer JWT when present (never in query strings). */
export const request = createAxiosInstance(BACKEND_URLS.rest, true);
/** Bridge/relayer API — uses its own HMAC headers, not SIWE JWT. */
export const bridgeRequest = createAxiosInstance(BACKEND_URLS.bridge, false);
